import axios from 'axios';
const rootPath = '/contacts/call_lists';

export function createCallList(body, callBack) {
  return axios.post(rootPath, body)
    .then((response) => {
      callBack(response.data.call_list);
    }).catch(() => {
      alert("There was a failure to create the call list. Please try again later.");
    });
}
